// extracted by mini-css-extract-plugin
export var component = "CalendarBadge-module--component--h20va";
export var day = "CalendarBadge-module--day--h6w-d";
export var month = "CalendarBadge-module--month--lghPn";